import React from 'react';
import { string } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';
import { useStoreId } from '@thd-nucleus/experience-context';
import {
  number as numberType,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';

const pepMetadataHandler = ({ data }) => {

  if (!data?.product) return null;

  const { identifiers } = data?.product || {};

  const title = identifiers?.productLabel || 'The HomeDepot';
  const tags = [];

  tags.push(new TitleTag(title));
  tags.push(new MetaTag({ name: 'robots', content: 'NOINDEX, NOFOLLOW', id: 'robots' }));
  tags.push(new LinkTag({ rel: 'canonical', href: 'https://www.homedepot.com/', id: 'canonical' }));
  return tags;
};

const ProductEntryMetadata = ({ itemId }) => {
  const storeId = useStoreId();
  const productOptions = {
    variables: {
      itemId,
      storeId
    },
    alias: 'Metadata'
  };
  const { data, loading, error } = useDataModel('product', productOptions);

  useHelmet('pepMetadata', { data }, pepMetadataHandler, [itemId, storeId]);
  return null;
};

ProductEntryMetadata.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      canonicalUrl: stringType(),
      itemId: stringType(),
      modelNumber: stringType(),
      productLabel: stringType(),
      storeSkuNumber: stringType(),
      upcGtin13: stringType()
    }),
    pricing: params({ storeId: stringType() }).shape({
      value: numberType({ float: true })
    })
  })
};
ProductEntryMetadata.propTypes = {
  itemId: string.isRequired
};

export { ProductEntryMetadata };
